import { useEffect, useRef } from 'react';
export function useTabListKeys() {
    const ref = useRef(null);
    // Deliberately un-gated by a dependency list: the selected tab changes on
    // re-render, and this is the render-completion hook that follows it.
    useEffect(() => {
        const node = ref.current;
        if (!node)
            return;
        const tabs = Array.from(node.querySelectorAll('[role="tab"]'));
        // If nothing is marked selected — a strip mid-transition, or one whose
        // selection lives elsewhere — leave the first tab reachable rather than
        // stranding the strip outside the tab order entirely.
        const anySelected = tabs.some((t) => t.getAttribute('aria-selected') === 'true');
        tabs.forEach((tab, i) => {
            const selected = anySelected ? tab.getAttribute('aria-selected') === 'true' : i === 0;
            tab.tabIndex = selected ? 0 : -1;
        });
    });
    const onKeyDown = (e) => {
        const node = ref.current;
        if (!node)
            return;
        const tabs = Array.from(node.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0)
            return;
        const from = tabs.indexOf(document.activeElement);
        if (from === -1)
            return;
        let to;
        switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                to = (from + 1) % tabs.length;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                to = (from - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                to = 0;
                break;
            case 'End':
                to = tabs.length - 1;
                break;
            default:
                return;
        }
        e.preventDefault();
        const next = tabs[to];
        if (!next)
            return;
        next.focus();
        next.click();
    };
    return { ref, onKeyDown };
}
//# sourceMappingURL=useTabListKeys.js.map